<div class="casino-mobilestories-container" [ngStyle]="{ 'background-color': promotionsBgClr }">
    <div
        class="mobilestories-carousel"
        [ngClass]="{ 'instacarousal': storyData.instaPromoList?.length <= 4, 'touch-mobilestories-carousel': isTouch }">
        <vn-swiper [swiperOptions]="swiperOptions">
            <div class="swiper-slide" *ngFor="let data of storyData.instaPromoList; let i = index">
                <div class="casino-instaPromo">
                    <div class="story-list">
                        <div
                            class="{{ storyIconShape }} casino-mobilestories-promo-icon"
                            *ngIf="data"
                            [ngStyle]="{ 'border-color': data.viewed ? viewedPromotionBrClr : notviewedPromotionBrClr }"
                            [ngClass]="{ viewed: data.viewed }">
                            <div class="story" (click)="openStoryDialog(i)">
                                <cc-instagram-promo-image [storyData]="data"></cc-instagram-promo-image>
                            </div>
                            <span
                                class="theme-check"
                                *ngIf="showStoryViewedTickMark && data.viewed"
                                [ngStyle]="{ 'background-color': themeCheckBgClr, 'color': themeCheckClr }"
                                [ngClass]="{ rhombustyle: storyIconShape === 'rhombus' }"></span>
                        </div>
                        @defer (on immediate) {
                            <span
                                class="promo-name"
                                [ngClass]="{ viewedClr: data.viewed }"
                                [ngStyle]="{ color: data.viewed ? viewedpromotionTxtClr : promotionTxtClr }"
                                >{{ data.promoTitle }}</span
                            >
                        }
                    </div>
                </div>
            </div>
        </vn-swiper>
    </div>
</div>
